/**
 * Labstep
 *
 * @module components/OrderRequest/Form/fields
 * @desc Form Fields for OrderRequest
 */

import { currencies } from 'labstep-web/constants/currencies';
import { FieldType } from 'labstep-web/constants/form';
import type {
  FieldWithoutActionProps,
  IFieldTypeSearchSelectProps,
} from 'labstep-web/core/Form/Reusable/types';
import { Resource } from 'labstep-web/models/resource.model';
import rules from 'labstep-web/services/validation/rules';

export const DEFAULT_QUANTITY_VALUE = 1;

export const fieldQuantity: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'quantity',
  fieldLabel: 'Number of Items',
  placeholder: 'Enter number of items requested',
  validation: rules.order_request.quantity,
};

export const fieldOrderRequestAmount: FieldWithoutActionProps = {
  fieldType: FieldType.Text,
  name: 'amount',
  fieldLabel: 'Price',
  placeholder: 'Enter Price',
  validation: rules.order_request.amount,
};

export const fieldResource: IFieldTypeSearchSelectProps = {
  fieldType: FieldType.SearchSelect,
  name: 'resource',
  elementProps: {
    entityName: 'resource',
    creatable: true,
  },
  fieldLabel: Resource.getHumanReadableEntityName(false, true),
  validation: rules.order_request.resource,
};

export const fieldUrgent: FieldWithoutActionProps = {
  name: 'is_urgent',
  fieldLabel: 'Urgent',
  fieldType: FieldType.Checkbox,
  validation: rules.order_request.is_urgent,
};

export const fieldOrderRequestCurrency: FieldWithoutActionProps = {
  fieldType: FieldType.ReactSelect,
  name: 'currency',
  fieldLabel: 'Currency',
  placeholder: 'Enter Currency',
  elementProps: {
    openMenuOnFocus: true,
    options: Object.values(currencies).map((currency) => ({
      label: `${currency.code} - ${currency.name}`,
      value: currency.code,
    })),
  },

  validation: rules.order_request.currency,
};
